module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }